module.exports = __webpack_public_path__ + "img/icon5.3a0df847.png";